import Vue from 'vue'
import $api from '@/shared/services/api'
export default {
    namespaced: true,
    state: {
        menus: null,
        visivel: true,
    },
    getters: {
        listaMenus(state){
            return state.menus
        }
    },
    mutations: {
        carregaMenus(state, menus){
            state.menus = menus
        },
    },
    actions: {
        carregaMenus({ commit, dispatch }){
            const requisicao = $api.cGet(
                Vue.prototype.$urlBase + '/menus/lista', {
                    plugin: Vue.prototype.$url.module,
                    //url: window.location.pathname + window.location.search
                }
            )
            requisicao.then((res) => {
                if (res.status === 'success') {
                    dispatch('listaEstilizaMenus', res.data).then(menus => {
                        commit('carregaMenus', menus)
                    })
                }
            }).catch((erro) => {
                console.log(erro)
            });
            return requisicao
        },
        listaEstilizaMenus(_, menus) {
            const parametrosLink = window.location.pathname + window.location.search;
        
            if (!Array.isArray(menus)) {
                console.warn('listaEstilizaMenus: menus não é um array', menus);
                return Promise.resolve([]);
            }
        
            const menusEstilizados = menus.map(menu => {
                menu.Menu.classe_li = '';
        
                const filhos = Array.isArray(menu.Filho)
                    ? menu.Filho
                    : Object.values(menu.Filho || {});
        
                if (filhos.length) {
                    menu.Menu.classe_li = 'treeview';
        
                    menu.Filho = filhos.map(menuHer => {
                        menuHer.classe_li = '';
                        menuHer.classe_a = '';
        
                        if (parametrosLink === menuHer.link) {
                            menu.Menu.classe_li = 'active treeview';
                            menuHer.classe_a = 'bold';
                        }
        
                        const netos = Array.isArray(menuHer.Neto)
                            ? menuHer.Neto
                            : Object.values(menuHer.Neto || {});
        
                        if (netos.length) {
                            menuHer.classe_li = 'treeview';
        
                            menuHer.Neto = netos.map(menuAux => {
                                menuAux.classe_a = '';
        
                                if (parametrosLink === menuAux.link) {
                                    menu.Menu.classe_li = 'active treeview';
                                    menuHer.classe_li = 'active treeview';
                                    menuAux.classe_a = 'bold';
                                }
        
                                return menuAux;
                            });
                        }
        
                        return menuHer;
                    });
                }
        
                return menu;
            });

            return Promise.resolve(menusEstilizados);
        }                      
    },
}
